<template>
  <div>
    <div class="strike mb-5"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/page1/strike.vue